import { render, staticRenderFns } from "./InboundModal.vue?vue&type=template&id=34301e2a&scoped=true&"
import script from "./InboundModal.vue?vue&type=script&lang=js&"
export * from "./InboundModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34301e2a",
  null
  
)

export default component.exports